module.exports = __webpack_public_path__ + "static/media/Blockchain.42b553f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Tracks/img/newlogos/Blockchain.svg
// module id = 242
// module chunks = 0